import React from 'react';
import { FadeIn } from './FadeIn';
import { Mail, MapPin, ShieldCheck, Clock, Phone } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  return <section id="contacto" className="w-full bg-navy-900 py-20 sm:py-28 relative overflow-hidden" data-id="element-70">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber to-transparent opacity-50" data-id="element-71"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-72">
        <FadeIn data-id="element-73">
          <div className="text-center mb-16" data-id="element-74">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-6" data-id="element-75">
              {t('contact.title')}
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-76">
              {t('contact.subtitle')}
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-77">
          <FadeIn delay={0.2} data-id="element-78">
            <div className="bg-navy-800 border border-steel-dark rounded-2xl p-8 sm:p-10 shadow-2xl" data-id="element-79">
              <div className="space-y-8" data-id="element-80">
                <a href="mailto:itzelrojasramirez51@gmail.com" className="flex items-center gap-6 group" data-id="element-81">
                  <div className="w-14 h-14 rounded-full bg-amber/10 flex items-center justify-center group-hover:bg-amber/20 transition-colors" data-id="element-82">
                    <Mail className="w-7 h-7 text-amber" data-id="element-83" />
                  </div>
                  <div data-id="element-84">
                    <p className="text-sm text-gray-400 font-semibold uppercase tracking-wider mb-1" data-id="element-85">
                      {t('contact.email')}
                    </p>
                    <p className="text-sm sm:text-lg md:text-xl text-white font-bold group-hover:text-amber transition-colors break-all" data-id="element-86">
                      itzelrojasramirez51@gmail.com
                    </p>
                  </div>
                </a>

                <div className="flex items-start gap-6" data-id="element-87">
                  <div className="w-14 h-14 rounded-full bg-amber/10 flex items-center justify-center flex-shrink-0" data-id="element-88">
                    <Phone className="w-7 h-7 text-amber" data-id="element-89" />
                  </div>
                  <div data-id="element-90">
                    <p className="text-sm text-gray-400 font-semibold uppercase tracking-wider mb-1" data-id="element-91">
                      {t('contact.phone')}
                    </p>
                    <div className="space-y-2" data-id="element-92">
                      <a href="tel:+529531513525" className="block text-lg text-white font-bold hover:text-amber transition-colors" data-id="element-93">
                        +52 953 151 3525
                      </a>
                      <a href="tel:+529532127674" className="block text-lg text-white font-bold hover:text-amber transition-colors" data-id="element-94">
                        +52 953 212 7674
                      </a>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-95">
                  <div className="w-14 h-14 rounded-full bg-steel/10 flex items-center justify-center flex-shrink-0" data-id="element-96">
                    <MapPin className="w-7 h-7 text-steel" data-id="element-97" />
                  </div>
                  <div data-id="element-98">
                    <p className="text-sm text-gray-400 font-semibold uppercase tracking-wider mb-1" data-id="element-99">
                      {t('contact.location')}
                    </p>
                    <p className="text-lg text-white leading-relaxed mb-3" data-id="element-100">
                      Calle 2 de Abril #134
                      <br data-id="element-101" />
                      Colonia Antonio de León
                      <br data-id="element-102" />
                      Huajuapan de León, Oaxaca
                    </p>
                    <a href="https://www.google.com/maps/search/136+Primera+Calle+2+de+Abril,+Huajuapan+de+León,+Oaxaca" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-steel/20 hover:bg-steel/40 text-white text-sm font-semibold rounded-md transition-colors duration-200 border border-steel-dark/50" data-id="element-103">
                      <MapPin className="w-4 h-4" data-id="element-104" />
                      {t('contact.map')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-105">
            <div className="space-y-8" data-id="element-106">
              <div className="flex items-start gap-4" data-id="element-107">
                <ShieldCheck className="w-8 h-8 text-amber flex-shrink-0 mt-1" data-id="element-108" />
                <div data-id="element-109">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-110">
                    {t('contact.trust1.title')}
                  </h3>
                  <p className="text-gray-400" data-id="element-111">{t('contact.trust1.desc')}</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-112">
                <Clock className="w-8 h-8 text-amber flex-shrink-0 mt-1" data-id="element-113" />
                <div data-id="element-114">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-115">
                    {t('contact.trust2.title')}
                  </h3>
                  <p className="text-gray-400" data-id="element-116">{t('contact.trust2.desc')}</p>
                </div>
              </div>

              <div className="mt-10 pt-8 border-t border-steel-dark/50" data-id="element-117">
                <p className="text-2xl text-amber italic font-medium" data-id="element-118">
                  {t('contact.quote')}
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}